import { matchPath, useNavigate } from "react-router-dom";

//Leaving the parameter empty in any path will result in the path 'pattern' being used - e.g. ":itemID".
export type Path =
  | "/"
  | "/auth"
  | "/reset-password"
  | "/my-account"
  | "/users"
  | "/orders"
  | "/orders/:id"
  | "/products"
  | "/terms"
  | "/privacy-policy"
  | "/cookie-policy";

export const usePaths = () => {
  const navigate = useNavigate();

  const home = "/";
  const auth = "/auth";
  const resetPassword = "/reset-password";
  const myAccount = "/my-account";
  const users = "/users";
  const orders = "/orders";
  const orderDetail = (orderId: string) => `/orders/${orderId}`;
  const products = "/products";
  const terms = "/terms";
  const cookiePolicy = "/cookie-policy";
  const privacyPolicy = "/privacy-policy";

  const navigateTo = (path: string) => {
    if (!pathMatches(window.location.pathname, path)) {
      navigate(path);
    }
  };

  const navigateToIgnoringPathMatch = (path: string) => {
    navigate(path);
  };

  const pathMatches = (path1: string, path2: string): boolean => {
    const path1WithoutTrailingPath = path1.replace(/\/$/, "");
    const path2WithoutTrailingPath = path2.replace(/\/$/, "");
    return path1WithoutTrailingPath === path2WithoutTrailingPath;
  };

  const isOnPage = (path: string): boolean => {
    return matchPath({ path, end: false }, window.location.pathname) !== null;
  };

  return {
    navigateTo,
    navigateToIgnoringPathMatch,
    pathMatches,
    isOnPage,
    home,
    auth,
    resetPassword,
    myAccount,
    users,
    orders,
    orderDetail,
    products,
    terms,
    cookiePolicy,
    privacyPolicy,
  } as const;
};
